import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout, { Clause, Fact, Email } from './LegalLayout';
import { LEGAL } from './legalDetails';

export default function About() {
  return (
    <LegalLayout title="About Pulso">

      <Clause n={1}>Who we are</Clause>
      <p>
        Pulso is owned and operated by <strong>{LEGAL.companyName}</strong>, a company registered in South Africa.
      </p>
      <p>
        Pulso is built and marketed under the <strong>{LEGAL.brandName}</strong> brand. Imaginarium is a
        subsidiary of {LEGAL.companyName}. The websites {LEGAL.siteDomain} and{' '}
        <a href={LEGAL.brandUrl} target="_blank" rel="noreferrer">imgnrm.com</a> are operated by{' '}
        {LEGAL.companyName}. Wherever you see "Pulso by Imaginarium", the company responsible
        is {LEGAL.companyName}.
      </p>

      <Clause n={2}>Company details</Clause>
      <div className="lg-table-wrap">
        <table className="lg-table">
          <tbody>
            <tr><th scope="row">Registered name</th><td>{LEGAL.companyName}</td></tr>
            <tr><th scope="row">Registration number</th><td><Fact value={LEGAL.regNumber} /> (CIPC, South Africa)</td></tr>
            <tr><th scope="row">Physical address</th><td><Fact value={LEGAL.address} /></td></tr>
            <tr><th scope="row">Email</th><td><Email value={LEGAL.contactEmail} /></td></tr>
            <tr>
              <th scope="row">Information Officer</th>
              <td>
                {LEGAL.informationOfficerEmails.map((email, i) => (
                  <React.Fragment key={email}>{i > 0 && ', '}<Email value={email} /></React.Fragment>
                ))}
              </td>
            </tr>
            <tr><th scope="row">Brand</th><td>{LEGAL.brandName}, a subsidiary of {LEGAL.companyName}</td></tr>
            <tr><th scope="row">Website</th><td>{LEGAL.siteDomain}</td></tr>
          </tbody>
        </table>
      </div>

      <Clause n={3}>What Pulso does</Clause>
      <p>
        Pulso helps organisations receive reports, grievances and feedback from workers and communities by
        WhatsApp, SMS, email and web form, and helps them respond. {LEGAL.companyName} provides Pulso to those
        organisations and processes messages on their behalf.
      </p>

      <Clause n={4}>Policies</Clause>
      <ul>
        <li><Link to="/privacy">Privacy Policy</Link></li>
        <li><Link to="/terms">Terms of Service</Link></li>
        <li><Link to="/data-deletion">How to delete your data</Link></li>
      </ul>

    </LegalLayout>
  );
}
